import apiClient from './api';

export type DroneServiceType = 'mapping' | 'spraying' | 'ch4_awd' | 'soil_nutrient';

export function fieldServiceTitle(serviceType: DroneServiceType | null): string {
  if (serviceType === 'spraying') return 'Request Drone Spraying';
  if (serviceType === 'ch4_awd') return 'Request CH4 & AWD Sensors';
  if (serviceType === 'soil_nutrient') return 'Request Soil & Nutrient Sensors';
  return 'Request Drone Mapping';
}
export type DroneAnalysisMode = 'field-level' | 'large-scale';

export type DroneServiceInquiryRequest = {
  service_type: DroneServiceType;
  email: string;
  phone: string;
  analysis_mode?: DroneAnalysisMode;
  farm_name?: string;
};

export type DroneServiceInquiryResponse = {
  success: boolean;
  message: string;
};

class DroneServiceService {
  async submitInquiry(body: DroneServiceInquiryRequest): Promise<DroneServiceInquiryResponse> {
    const response = await apiClient.post<DroneServiceInquiryResponse>('/drone-service-inquiry', body);
    return response.data;
  }
}

export default new DroneServiceService();
